import * as React from "react"
import { cn } from "../utils"

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  leadingIcon?: React.ReactNode
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = "text", leadingIcon, ...props }, ref) => {
    return (
      <div className="relative w-full">
        {leadingIcon && (
          <span className="absolute left-3 top-1/2 -translate-y-1/2 inline-flex shrink-0 w-[17px] h-[17px] text-faint pointer-events-none">
            {leadingIcon}
          </span>
        )}
        <input
          type={type}
          className={cn(
            "flex h-[42px] w-full rounded-sm border border-border-strong bg-surface px-3 text-[14.5px] text-foreground placeholder:text-faint",
            "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:border-primary",
            "disabled:opacity-50 disabled:cursor-not-allowed",
            "transition-colors",
            leadingIcon && "pl-10",
            className
          )}
          ref={ref}
          {...props}
        />
      </div>
    )
  }
)
Input.displayName = "Input"
